import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import SecureBaseStore from "./SecureBaseStore";
import LoadingStates from "../constants/states/LoadingStates";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import ActionResultEvents from "../constants/events/ActionResultEvents";


class SpaceReservationState {
    constructor(
        loadingState,
        reservationRequests,
        activeReservations,
        history
    ) {
        this.loadingState = loadingState;
        this.reservationRequests = reservationRequests;
        this.activeReservations = activeReservations;
        this.history = history;
    }

    equals(other) {
        return this.loadingState ===other.loadingState &&
            this.arraysEqual(this.reservationRequests, other.reservationRequests) &&
            this.arraysEqual(this.activeReservations, other.activeReservations) &&
            this.arraysEqual(this.history, other.history);
    }

    arraysEqual = (a1, a2) =>
        a1.length === a2.length && a1.every((o, idx) => o.equals(a2[idx]));
}

class ImmutableSpaceReservationStateBuilder {

    constructor() {
        this.loadingState = LoadingStates.INITIALIZED;
        this.reservationRequests = [];
        this.activeReservations = [];
        this.history = [];
    }

    static fromState(state) {
        return new ImmutableSpaceReservationStateBuilder()
            .setLoadingState(state.loadingState)
            .setReservationRequests(state.reservationRequests)
            .setActiveReservations(state.activeReservations)
            .setHistory(state.history)
    }

    setLoadingState(loadingState) {
        this.loadingState = loadingState;
        return this;
    }

    setReservationRequests(reservationRequests) {
        this.reservationRequests = reservationRequests;
        return this;
    }

    setActiveReservations(activeReservations) {
        this.activeReservations = activeReservations;
        return this;
    }

    setHistory(history) {
        this.history = history;
        return this;
    }

    build() {
        return Object.freeze(
            new SpaceReservationState(
                this.loadingState,
                this.reservationRequests,
                this.activeReservations,
                this.history
            ));
    }
}


class SpaceReservationStore extends SecureBaseStore {

    constructor() {
        super(StoreUpdateEvents.SPACE_RESERVATIONS_STORE_UPDATED, ImmutableSpaceReservationStateBuilder);
        this.subscribeToEvent(UIInteractionEvents.SPACE_RESERVATIONS_UNMOUNTED, this.resetStore);
        this.subscribeToEvent(ActionResultEvents.MEMBER_SPACES_RESERVATIONS_LOADED, this.handleMemberSpacesReservationsLoaded);
        this.subscribeToEvent(UIInteractionEvents.GET_MEMBER_SPACES_RESERVATIONS, this.handleLoading);
    }

    handleLoading = (topic, data) => {
        return new ImmutableSpaceReservationStateBuilder()
            .setLoadingState(LoadingStates.LOADING)
            .build();
    }

    handleMemberSpacesReservationsLoaded = (topic, data) => {
        return new ImmutableSpaceReservationStateBuilder()
            .setLoadingState(LoadingStates.FINISHED_LOADING)
            .setReservationRequests(data.reservationRequests)
            .setActiveReservations(data.activeReservations)
            .setHistory(data.history)
            .build();
    }
}

export default new SpaceReservationStore();